import getStoreProperty from "components/ProjectNonSpecificComponents/DevTools/Functions/getStoreProperty"
import {
	TOnInputChangeReactSelect,
	TReactSelectOption,
	TReactSelectSelectedOptions,
} from "components/ProjectSpecificComponents/Interfaces/ExternalComponentsInterfaces"
import React, { useMemo } from "react"
import ReactSelect, { ActionMeta, KeyboardEventHandler, StylesConfig } from "react-select"

interface Props {
	valueKey?: string
	inputValue?: string
	options?: TReactSelectOption[]
	value?: TReactSelectSelectedOptions
	isMulti?: boolean
	isDisabled?: boolean
	isSearchable?: boolean
	isLoading?: boolean
	onChange?: (
		selectedOption: TReactSelectSelectedOptions,
		triggeredAction?: ActionMeta<any>
	) => void
	onInputChange?: TOnInputChangeReactSelect
	onKeyDown?: KeyboardEventHandler
	placeholder?: string
	className?: string
}

interface Props {
	valueKey?: string
	inputValue?: string
	options?: TReactSelectOption[]
	value?: TReactSelectSelectedOptions
	isMulti?: boolean
	isDisabled?: boolean
	isSearchable?: boolean
	isLoading?: boolean
	onChange?: (
		selectedOption: TReactSelectSelectedOptions,
		triggeredAction?: ActionMeta<any>
	) => void
	onInputChange?: TOnInputChangeReactSelect
	onKeyDown?: KeyboardEventHandler
	placeholder?: string
}

const Select = ({
	valueKey,
	inputValue,
	options,
	value,
	isMulti = false,
	isDisabled = false,
	isLoading = false,
	isSearchable,
	onChange = () => {},
	onInputChange,
	onKeyDown,
	placeholder,
	className = "",
}: Props) => {
	const controlledValueByKey = useMemo(() => {
		var foundValue = null
		if (valueKey != null && options) {
			let foundOptions = options.find(({ value }) => value == valueKey)
			if (foundOptions) foundValue = foundOptions
		}
		return foundValue
	}, [value, inputValue, valueKey, options])

	const selectStyles: StylesConfig<TReactSelectOption, false> = {
		container: (base) => ({
			...base,
			width: "100%",
			fontSize: 14,
		}),
		control: (base) => ({
			...base,
			border: "1px solid var(--gray-c2)",
			borderRadius: 5,
			height: "fit-content",
			padding: "0 0 0 8px",
			backgroundColor: "var(--white)",
			cursor: "pointer",
			opacity: isDisabled ? 0.5 : 1,
			boxShadow: "none",
		}),
		menu: (base) => ({
			...base,
			boxShadow: "none",
			border: "1px solid var(--gray-c2)",
			borderRadius: 5,
			zIndex: 100
		}),
		singleValue: (base) => ({
			...base,
			color: "inherit",
			fontSize: "14px",
		}),
		multiValue: (base) => ({
			...base,
			color: "inherit",
			fontSize: "14px",
		}),
		option: (base) => ({
			...base,
			fontSize: "14px",
			cursor: "pointer",
		}),
	}

	return isLoading ? (
		<ReactSelect
			styles={selectStyles}
			value={loading}
			inputValue={loading.label}
			options={loadingOptions}
			isMulti={isMulti}
			placeholder={loading.label}
			readOnly={true}
			isLoading={true}
		/>
	) : (
		<ReactSelect
			styles={selectStyles}
			value={value ?? controlledValueByKey ?? emptySelectOption}
			inputValue={inputValue}
			options={options}
			isMulti={isMulti}
			isSearchable={isSearchable}
			isDisabled={isLoading || isDisabled}
			isClearable
			menuShouldScrollIntoView={false}
			onChange={onChange}
			onInputChange={onInputChange}
			onKeyDown={onKeyDown}
			placeholder={placeholder}
			className={className}
		/>
	)
}

export default Select

const loading: TReactSelectOption = {
	value: "loading",
	label: "Loading...",
}
const loadingOptions = [loading]

const emptySelectOption: TReactSelectOption = { value: "", label: "" }
